module.exports = __webpack_public_path__ + "img/DK64855417.3b64a597.png";